export default {
  CUSTOMER_PERSON_REPOSITORY: Symbol.for('CUSTOMER_PERSON_REPOSITORY'),
  CUSTOMER_PERSON_STATE_MANAGER: Symbol.for('CUSTOMER_PERSON_STATE_MANAGER'),
  GET_CUSTOMER_PERSON_QUERY: Symbol.for('GET_CUSTOMER_PERSON_QUERY'),
};
